import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-dashboard-turns-types-request-zoom-card',
  templateUrl: './dashboard-turns-types-request-zoom-card.component.html',
  styleUrls: ['./dashboard-turns-types-request-zoom-card.component.scss']
})
export class DashboardTurnsTypesRequestZoomCardComponent implements OnInit, AfterViewInit {

  @ViewChild('requestTypes', { static: false }) requestTypesRef: ElementRef;
  ctx;
  myChart;
  title;
  colors;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              private dialogRef: MatDialogRef<MatDialog>) {
  }

  ngOnInit() {
    this.title = this.data.title;
    this.colors = this.data.colors;
  }

  ngAfterViewInit() {
    this.ctx = this.requestTypesRef.nativeElement.getContext('2d');
    this.renderChart(this.data.data);
  }

  public close() {
    this.dialogRef.close();
  }

  private renderChart(data) {
    if (this.myChart) {
      this.myChart.destroy();
    }
    const labels = [];
    const counts = [];

    data.forEach((d) => {
      labels.push(d.label);
      counts.push(d.count.reduce((accumulator, currentValue) => accumulator + currentValue));
    });

    const colors = this.colors.slice(0, counts.length);
    const hoverColors = colors.map(c => c = c + 'EE');
    const total = counts.reduce((accumulator, currentValue) => {
      return accumulator + currentValue;
    }, 0);

    this.myChart = new Chart(this.ctx, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Dataset 1',
            data: counts,
            backgroundColor: colors,
            borderColor: colors,
            hoverBackgroundColor: hoverColors,
            hoverBorderColor: hoverColors,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
          position: 'bottom',
          align: 'end',
          fontColor: '#aaaaaa',
          labels: {
            padding: 15,
            boxWidth: 20,
            fontColor: '#aaaaaa'
          }
        }
      },
      plugins: [{
        id: 'total',
        font: {
          size: 14
        },
        beforeDraw: (chart) => {
            const width = chart.width;
            const height = chart.height;
            const ctx = chart.ctx;
            ctx.restore();
            ctx.fillStyle = '#aaaaaa';
            const text12 = 'TOTAL';
            ctx.font = '14px sans-serif';
            ctx.fillText(text12, width / 2 - (ctx.measureText(text12).width / 2), height / 2 - 15 );
            const text11 = total;
            ctx.font = '34px sans-serif';
            ctx.fillText(text11, width / 2 - (ctx.measureText(text11).width / 2), height / 2 + 25);
            ctx.save();
        }
      }]
    });
  }
}
